/**
 * This component lets person to add previous job experiences.
 * in the end we form en array ctrl.user.experience, which consist of objects containing:
 *  - jobId - unique identifier, so job can be removed as well by it. It is also added as person can add few simular titles, so we can not
 *     use jobtitle to identify job with.
 *  - jobTitle - like "Kasse medarbejder"
 *  - employmentDuration - string like "0 - 6 months"
 *
 *
 * @type {{bindings: {}, controller: applicationExperience.applicationExperienceCtrl, templateUrl: application-experience.component.html}}
 */
var applicationExperience = {
    bindings : {
    },
    controller : function applicationExperienceCtrl ($scope, $sce, $timeout, $location, flux, actions, userStore) {
        
        var ctrl = this;
        var formData = {};

        ctrl.step = 0;
        ctrl.messages = [];
        ctrl.totalSteps = [0,1,2,3];

        ctrl.selectedJobTypeId = null;
        ctrl.selectedTitle = '';
        ctrl.jobTypes = [
            {
                id: '0',
                title: 'Restaurant og cafe',
                selected: false,
                titles: [
                    'Tjener',
                    'Ekspedient',
                    'Opvasker',
                    'Afrydder',
                    'Cafemedarbejder',
                    'Køkkenassistent',
                    'Garderobemedarbejder',
                    'Andet'
                ]
            },
            {
                id: '1',
                title: 'Butik',
                selected: false,
                titles: [
                    'Ekspedient',
                    'Salgsassistent',
                    'Butiksassistent',
                    'Kundemedarbejder',
                    'Butiksmedarbejder',
                    'Andet'
                ]
            },
            {
                id: '2',
                title: 'Supermarked og kiosk',
                selected: false,
                titles: [
                    'Servicemedarbejder',
                    'Salgsassistent i supermarked',
                    'Butiksassistent i supermarked',
                    'Kassemedarbejder',
                    'Butiksekspedient',
                    'Andet'
                ]
            },
            {
                id: '3',
                title: 'Lager',
                selected: false,
                titles: [
                    'Lagermedarbejder',
                    'Ungarbejder på lager',
                    'Andet'
                ]
            },
            {
                id: '4',
                title: 'Rengøring',
                selected: false,
                titles: [
                    'Rengøringsassistent',
                    'Rengøringsmedarbejder',
                    'Andet'
                ]
            },
            {
                id: '5',
                title: 'Salg og marketing',
                selected: false,
                titles: [
                    'Salgsmedarbejder',
                    'Telesælger',
                    'Phoner',
                    'Facer',
                    'Callcenter-medarbejder',
                    'Andet'
                ]
            },
            {
                id: '6',
                title: 'Transport',
                selected: false,
                titles: [
                    'Chauffør',
                    'Cykelbud',
                    'Avisomdeler',
                    'Reklameomdeler',
                    'Andet'
                ]
            },
            {
                id: '7',
                title: 'Børn og ældre',
                selected: false,
                titles: [
                    'Barnepige',
                    'Køkkenmedhjælper i daginstitution',
                    'Aktivitetsmedarbejder',
                    'Andet'
                ]
            },
            {
                id: 'other',
                title: 'Andet',
                selected: false
            }
        ];
        ctrl.duration = 0;
        // should duration be saved as "måned" or "måneder"..
        ctrl.monthForm = 'måneder';

        function init () {
            // we get user data available in local store
            ctrl.user = userStore.getUser();

            // if user have already some experience filled out, we go directly to step 1 and not ask user again if he had job before.
            if (ctrl.user.experience !== undefined && ctrl.user.experience !== 'none' && ctrl.user.experience.length !== 0) {
                ctrl.next();
            }
        }

        function link () {
            // we show a first welcome message to a user when element is loaded
            if (ctrl.step === 0){
                $timeout(function() {
                    ctrl.addMsg({
                        content: $sce.trustAsHtml('Har du haft et fritidsjob før? 😎 Tryk ja, hvis du har og nej, hvis du ikke har 👌'),
                        type: 'receive'
                    });
                }, 500);
            }
        }

        // going to certain step
        ctrl.goToStep = function(step){
            ctrl.step = step;
            // console.log('goToStep func');
            // console.log('ctrl.step');
            // console.log(ctrl.step);
            // console.log('--------- END goToStep func ---------');

            // show message for current step
            showStepMessage();
        };

        // going to next step
        ctrl.next = function(){
            ctrl.step++;
            // console.log('--- next func ---');
            // console.log('ctrl.step');
            // console.log(ctrl.step);

            // show message for current step
            showStepMessage();
        };

        // going to previous step
        ctrl.previous = function(){

            if (ctrl.step === 3 && ctrl.selectedJobTypeId === 'other') {
                ctrl.goToStep(2.5);
            } else {
                ctrl.step--;
            }

            // show message for current step
            showStepMessage();
        };

        // form submit of first step - choose job type - "Supermarket", "Slagter", etc.
        ctrl.submitJobTypeForm = function(){
            // if form got  submitted without selectedJobTypeId value, we show message
            if (ctrl.selectedJobTypeId === null){
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Ups du skal vælge en jobtype.'),
                    type: 'receive'
                });
            } else {
                // if form is submitted with "normal" value, we go to "choose jobtitle" step, otherwise we show a step for custom jobtitle.
                if (ctrl.selectedJobTypeId === 'other'){
                    // we reset title, in case user went back and have chosen existing jobtitle before.
                    ctrl.selectedTitle = '';
                    // show step 2.5
                    ctrl.goToStep(2.5);
                } else {
                    ctrl.next();
                }
            }
        };

        // form submit of second step - choose job title
        // this form is used both for step 2.5 and for step 3
        ctrl.submitJobTitleForm = function(){
            // console.log('submitJobTitleForm');
            // console.log('ctrl.selectedTitle');
            // console.log(ctrl.selectedTitle);

            // if selected title is empty, we show warning message
            if (ctrl.selectedTitle === ''){
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Ups du skal vælge en job titel.'),
                    type: 'receive'
                });
            } else {
                // Among existing job titles, we always in each category have a value "Andet". If this value is selelcted, it means
                // user want to add a custom title. Then we reset the current title value and show custom form.
                if (ctrl.selectedTitle === 'Andet') {
                    ctrl.selectedTitle = '';
                    ctrl.goToStep(2.5);
                } else {
                    // if form was submitted in step 2.5, which is custom job title step, we send user directly to step 3.
                    // if form was submitted on step 2, we just use "next" function to go to step 3.
                    // next function does "step++", and that's why we we can not use it in step 2.5, as it will result in step 3.5
                    // which does not exists
                    if (ctrl.step === 2.5){
                        ctrl.goToStep(3);
                    } else {
                        ctrl.next();
                    }
                }
            }
        };

        //  form submit of third step - choose job duration
        ctrl.selectJobDuration = function(){

            // if no duration is not selected, show a message
            if (ctrl.duration === 0){
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Ups du skal vælge hvor lang tid har du arbejdet som "' + ctrl.selectedTitle + '".'),
                    type: 'receive'
                });
            } else {

                if (ctrl.duration === 1) {
                    ctrl.monthForm = 'måned';
                }
                // show users "Job experience" data
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Du har valgt, at du har arbejdet som "' + ctrl.selectedTitle +'" i ' + ctrl.duration + ' ' + ctrl.monthForm + ' 🤗'),
                    type: 'send'
                });

                // ask about confirmation
                $timeout(function() {
                    ctrl.addMsg({
                        content: '<div>Det ser rigtig god ud. <a ng-click="$ctrl.stepConfirm()">Godkend dit valg ved at trykke her.</a><div>',
                        type: 'receive'
                    });
                }, 1000);
            }
        };

        // function which is called, when user confirms his selection by clicking $ctrl.stepConfirm() or directly in step "0"
        // function saves user data using "flux.dispatch"
        ctrl.saveUserData = function(experience){

            // if user does not have job experience, he can choose "No" during step "0" and we can set experience to none.
            if (experience === 'none') {
                formData.experience = experience;
            } else {
                // if we come here, user have confirmed his selection
                // define formData.experience object based on ctrl.user.experience value, which can be - "none", array, undefined or empty string ""
                if (ctrl.user.experience === '' || ctrl.user.experience === undefined || ctrl.user.experience === 'none') {
                    formData.experience = [];
                } else {
                    formData.experience = ctrl.user.experience;
                }

                // generate random Id with 4 letters
                var uniqueId = false;
                var jobId;
                while(!uniqueId) {
                    jobId = makeId();
                    // check with lodash if object with this id already exists..
                    var jobExperienceExistingObj = _.find(formData.experience, function(e) { return e.id === jobId; });
                    if (jobExperienceExistingObj === undefined) {
                        uniqueId = true;
                    }
                }

                // durationFormatted will form a string like "2 år 5 måneder"
                var durationFormatted = '';
                var years = Math.floor(ctrl.duration / 12);
                var months = ctrl.duration % 12;
                if (years > 0) {
                    durationFormatted = years + ' år og ';
                }
                if (months > 0) {
                    durationFormatted = durationFormatted + months + ' ' + ctrl.monthForm;
                }

                // add experience item
                formData.experience.push({
                    id: jobId,
                    jobTitle: ctrl.selectedTitle,
                    employmentDuration: durationFormatted
                });
            }

            // save user data with UPDATE_USER action, which expects formData object.
            flux.dispatch(actions.UPDATE_USER, formData);

            // redirect to main application page
            $location.path( "/din-ansoegning#!" );
        };

        // message is added to ctrl.messages array
        ctrl.addMsg = function addMsg(message) {
            message = {
                content: message.content,
                type: message.type
            };
            ctrl.messages.push(message);
        };
        
        // show message for current step
        function showStepMessage() {
            // we need to reset messages array if we come to the next step
            ctrl.messages = [];
            switch(ctrl.step){
                case 1:
                    ctrl.addMsg({
                        content: $sce.trustAsHtml('Fedt! Det er altid godt med joberfaring! 👍 Vælg hvor du tidligere har arbejdet. Hvis jobbet ikke står på listen, så tryk på "Andet"'),
                        type: 'receive'
                    });
                    break;
                case 2:
                    ctrl.addMsg({
                        content: $sce.trustAsHtml('Spændende. Hvad lavede du på jobbet? 🙂👏<br /> Vælg en jobtitel, der passer. Hvis der ikke er en titel, der passer, så klik på "Andet"'),
                        type: 'receive'
                    });
                    break;
                case 2.5:
                    ctrl.addMsg({
                        content: $sce.trustAsHtml('Havde du en anden jobtitel, for eksempel piccoline, fabriksmedarbejder, sæsonmedarbejder, så skriv den i feltet nedenunder 🙂'),
                        type: 'receive'
                    });
                    break;
                case 3:
                    ctrl.addMsg({
                        content: $sce.trustAsHtml('Hvor lang tid arbejdede du der? 😮✌'),
                        type: 'receive'
                    });
                    break;
            }
        }

        // generate random string to be used as job experience Id
        function makeId() {
            var text = "";
            var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-!+£$%&";

            for (var i = 0; i < 4; i++)
                text += possible.charAt(Math.floor(Math.random() * possible.length));

            return text;
        }

        ctrl.$onInit = init;
        ctrl.$postLink = link;

    },
    templateUrl: './angular/components/application-experience.component.html'
};